export const LANGS = {
  it: { label: 'Italiano', isRTL: false, speechLocale: 'it-IT' },
  en: { label: 'English', isRTL: false, speechLocale: 'en-US' },
} as const;

export type LangKey = keyof typeof LANGS;
export const DEFAULT_LANG: LangKey = 'it';

export const getSpeechLocale = (language: string): string => {
  const key = language?.toLowerCase().split('-')[0] as LangKey;
  return LANGS[key]?.speechLocale ?? LANGS[DEFAULT_LANG].speechLocale;
};
